import {PATCH, POST} from 'helpers/services/constants/API_CONSTANTS';
import {
  API_CREATE_STRIPE_CHECKOUT_SESSION,
  API_MARK_PAYMENT_DETAILS_AS_FINISHED,
  API_UPDATE_STRIPE_FLOW_COMPLETED
} from 'helpers/services/constants/API_ENDPOINTS';
import {request} from 'helpers/services/utils/request';

export const createStripeCheckoutSession = async (locationId, email) => {
  const response = await request(
    POST,
    API_CREATE_STRIPE_CHECKOUT_SESSION(locationId),
    {
      data: {customerEmail: email}
    }
  );
  return response?.data;
};

export const markPaymentDetailsAsFinished = async (locationId) => {
  const response = await request(
    PATCH,
    API_MARK_PAYMENT_DETAILS_AS_FINISHED(locationId),
    {
      data: {IsFinished: true}
    }
  );
  return response?.data;
};

export const updateStripeFlowCompleted = async (
  locationId,
  stripeFlowCompleted
) => {
  const response = await request(
    PATCH,
    API_UPDATE_STRIPE_FLOW_COMPLETED(locationId),
    {
      data: {StripeFlowCompleted: stripeFlowCompleted}
    }
  );
  return response?.data;
};
